// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline__3hcT-"};